import React from 'react';

import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';

import {AddressType} from 'desktop/types/addressType';

import {getAddressesSameness} from '../../store/selectors/deliveryStep/deliveryStep';
import {getShippingAddress} from '../../store/selectors/shippingAddress/shippingAddress';

import {Collapse} from '../collapse/collapse';
import {DeliveryFormFields} from '../deliveryFormFields/deliveryFormFields';
import {DeliveryFormTitle} from '../deliveryFormTitle/deliveryFormTitle';
import {ShippingAddressConnected} from '../shippingAddress/shippingAddress';

export type PropsType = {
    isSameAddress: boolean;
    shippingAddress: AddressType;
};

const requiredFields = [
    'address',
    'city',
    'country',
    'firstName',
    'lastName',
    'phone',
    'postal',
    'state',
    'regionID',
];

/**
 * Delivery form with validate for checkout
 *
 * @constructor
 */
export const DeliveryForm: React.FC<PropsType> = ({isSameAddress, shippingAddress}) => {
    const isShippingAddressComplete = requiredFields.every(
        field => shippingAddress[field]?.value !== '',
    );

    return (
        <>
            <Collapse isOpen={isSameAddress || !isShippingAddressComplete}>
                <DeliveryFormTitle isRequired>Shipping address</DeliveryFormTitle>
                <DeliveryFormFields target="shippingAddress" />
            </Collapse>
            <Collapse isOpen={!isSameAddress && isShippingAddressComplete}>
                <ShippingAddressConnected />
            </Collapse>

            <Collapse isOpen={!isSameAddress}>
                <DeliveryFormTitle isRequired>Billing address</DeliveryFormTitle>
                <DeliveryFormFields target="billingAddress" />
            </Collapse>
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    isSameAddress: getAddressesSameness(store),
    shippingAddress: getShippingAddress(store),
});

export const DeliveryFormConnected = connect(mapStateToProps)(DeliveryForm);
